// Phase G3 Stage 1a: /play/ kid loop entry.
//
// T1.3 Phase C: the Storybook tab landing is now PathHome (the ported
// Lovable storybook path) — the kid lands directly on the path, where the
// glowing today stone is the parent-priors-derived skill. StorybookHome
// (the previous bookshelf landing) and AdventureMap are left on disk but
// unreached from production nav (cleanup PR later).
import { createFileRoute } from "@tanstack/react-router";
import { PathHome } from "@/screens/PathHome";
import { KidRouteError } from "@/components/RouterErrorFallback";

export const Route = createFileRoute("/play/")({
  errorComponent: KidRouteError, // MA-107
  component: PathHome,
});
